import { useEffect, useRef, useState } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";

import { useWorkspaces } from "./WorkspaceProvider";

import { LoadingScreen } from "@/shared/components/LoadingScreen";
import { ApiError } from "@/shared/api/client";

export function WorkspaceIndex() {
  const { activeWorkspace, isLoading } = useWorkspaces();

  if (isLoading) return <LoadingScreen label="Loading workspaces…" />;

  return activeWorkspace ? (
    <Navigate replace to={`/app/${activeWorkspace.id}`} />
  ) : (
    <Navigate replace to="/" />
  );
}

export function WorkspaceRoute() {
  const { tenantId = "" } = useParams();
  const { workspaces, activeWorkspace, isLoading, switchWorkspace } =
    useWorkspaces();
  const requested = workspaces.find(({ id }) => id === tenantId);
  const switching = useRef<string | null>(null);
  const [switchDenied, setSwitchDenied] = useState(false);

  useEffect(() => {
    if (
      !requested ||
      requested.id === activeWorkspace?.id ||
      switching.current === requested.id
    )
      return;
    switching.current = requested.id;
    void switchWorkspace(requested.id).catch((error: unknown) => {
      switching.current = null;
      if (error instanceof ApiError && error.status === 403)
        setSwitchDenied(true);
    });
  }, [activeWorkspace?.id, requested, switchWorkspace]);
  if (isLoading) return <LoadingScreen label="Loading workspace…" />;
  if (!requested)
    return activeWorkspace ? (
      <Navigate replace to={`/app/${activeWorkspace.id}`} />
    ) : (
      <Navigate replace to="/" />
    );
  if (switchDenied)
    return activeWorkspace ? (
      <Navigate replace to={`/app/${activeWorkspace.id}`} />
    ) : (
      <Navigate replace to="/" />
    );
  if (requested.id !== activeWorkspace?.id)
    return <LoadingScreen label="Switching workspace…" />;

  return <Outlet />;
}
